export default function arrowPosition(position) {
  switch (position) {
    case 'top':
      return {
        alignItems: 'center',
        bottom: '-8px',
        flexDirection: 'column',
        height: 8,
        justifyContent: 'center',
        left: 0,
        width: '100%',
      };
    case 'bottom':
      return {
        alignItems: 'center',
        flexDirection: 'column',
        height: 8,
        justifyContent: 'center',
        left: 0,
        top: '-8px',
        width: '100%',
      };
    default:
      return {
        alignItems: 'center',
        flexDirection: 'column',
        height: 8,
        justifyContent: 'center',
        left: 0,
        top: '-8px',
        width: '100%',
      };
  }
}
